<!-- About us start -->
<div class="section">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 mb-lg-30 ct-single-img-wrapper">
                <img src="assets/img1/shawrma.png" alt="img">
                <div class="ct-dots"></div>
            </div>
            <div class="col-lg-6">
                <div class="section-title-wrap mr-lg-30">
                    <h5 class="custom-primary">A propos</h5>
                    <h2 class="title">Pimentez votre journée avec des délices tunisiens et des savoureux shawarmas </h2>
                    <p class="subtitle">
                        En 2019, la famille Arfaoui a ouvert le restaurant Resto Pita Shawarma INC. à Lévis.
                        Fondé sur des valeurs familiales et traditionnelles, ce restaurant est une véritable réussite.
                    </p>
                    <p class="subtitle">
                        En restant fidèle à sa vision originale, qui consiste à offrir une cuisine méditerranéenne
                        authentique,
                        le menu du Resto Pita Shawarma propose une sélection de plats typiquement méditerranéens tels
                        que le Shish Taouk, le Shawarma, les Pitas, les assiettes de patates grecques, le Falafel, le
                        sandwich renversé et même des pizzas,
                        le tout préparé selon des recettes familiales transmises de génération en génération.
                    </p>
                    <p class="subtitle">
                        Grâce à cette approche authentique et à la qualité exceptionnelle de ses plats, le restaurant
                        Resto Pita Shawarma INC. est devenu une destination incontournable pour les passionnés de
                        cuisine méditerranéenne à Lévis et au-delà.
                    </p>
                    <div class="signature">
                        <img style="border-radius: 15px;" src="assets/img1/logo-2.jpg" alt="signature">
                    </div>
                    <!-- <a routerLink="/menu-v1" class="btn-custom">Check our Menu</a> -->
                </div>
            </div>
        </div>
    </div>
</div>
<!-- About us End -->